import StepIndicator, { StepIndicatorProps } from './StepIndicator';

export type { StepIndicatorProps };
export default StepIndicator;
